"use strict";

export default angular.module("UrlService", []).factory("Urls", [
  "$http",
  "$rootScope",
  "Flash",
  function ($http, $rootScope, Flash) {

    function loadUrlTemplates(callback,) {

      $http
        .get('api/urls')
        .success(function (data) {
          callback(data);
        })
        .error(function (data) {
          Flash.error("Error getting urls");
          callback(data);
        });
    }

    return {
      loadUrlTemplates: loadUrlTemplates
    };
  }
]);
